import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./fonts.css";

import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
*{
  box-sizing: border-box;
  font-family: "Figtree", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 350;
  line-height: 1.2;
  ::selection {
  background-color: #FF2020;
  color: white;
}
}
a{
  text-decoration: none;
}
input, select, textarea {
    border: none;
    outline: none;
    background-color: transparent;
  }
button {
    cursor: pointer;
    border: none;
    background: none;
  }
h1{
  font-family: 'PlayfairDisplay', serif;
  color:#222222;
  font-weight: 300;
  line-height: 55px;
  font-size: 80px;
  display: block;
  letter-spacing: -1px;
}
h2{
  font-family: 'PlayfairDisplay', serif;
  color: #222222;
  font-weight: 300;
  line-height: 25px;
  font-size: 12px;
  display: block;
}
span, p, ul, ol, li, td, th, blockquote{
  font-family: 'Figtree', -apple-system, sans-serif;
  font-weight: 300;
  color: #444444;
  line-height: 1.5rem;
  font-size: 14px;
  display: block;
}

/* Prevent horizontal scroll */
html, body {
  overflow-x: clip;
  width: 100%;
}

#root {
  width: 100%;
  overflow-x: clip;
}

`;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>,
);
